var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSwapHorizontalCircleFilled = function SvgSwapHorizontalCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M18.894 18.894c3.808-3.807 3.808-9.98 0-13.788-3.807-3.808-9.98-3.808-13.788 0-3.808 3.807-3.808 9.98 0 13.788 3.807 3.808 9.98 3.808 13.788 0ZM14.53 6.47a.75.75 0 1 0-1.06 1.06l.72.72H8a.75.75 0 0 0 0 1.5h6.19l-.72.72a.75.75 0 1 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06l-2-2Zm-4 7.06a.75.75 0 1 0-1.06-1.06l-2 2a.75.75 0 0 0 0 1.06l2 2a.75.75 0 1 0 1.06-1.06l-.72-.72H16a.75.75 0 0 0 0-1.5H9.81l.72-.72Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSwapHorizontalCircleFilled);
export default ForwardRef;